import React, {useState, useEffect, useReducer} from 'react'
import Layout from '../components/layout'
import { useNavigate } from "react-router-dom"
import dayjs from 'dayjs'
import Container from '@mui/material/Container'
import Fab from '@mui/material/Fab'
import { useTheme } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import Button from '@mui/material/Button'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import DialogContentText from '@mui/material/DialogContentText'
import Dialog from '@mui/material/Dialog'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Slide from '@mui/material/Slide'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import Checkbox from '@mui/material/Checkbox'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import AddIcon from '@mui/icons-material/Add'
import CloseIcon from '@mui/icons-material/Close'
import PropTypes from 'prop-types'
import MonthPeriods from '../components/monthPeriods'
import ExpenseCardDetails from '../components/expenseCardDetails'
import TotalExpensesCard from '../components/totalExpensesCard'
import categoryList from '../utils/categoryList'
import ExpenseCard from '../components/expenseCard'
import transactionReducer from '../services/transactionReducer'
import {Helmet} from "react-helmet-async"

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
            <Box p={3}>
                <div>{children}</div>
            </Box>
            )}
        </div>
    )
}
  
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}
  
function a11yProps(index) {
    return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
    }
}
  
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})
  
const table = () => {
    let out = []
    const data = dayjs(Date()).format('M')
    for (let i = data; i > data - 11; i--) {
        if(i <= 0){
            out.push({index : i+12, currentYear: false})
        }else{
            out.push({index: parseInt(i), currentYear: true})
        }
    }
    return out
}

export default function History(){
    let navigate = useNavigate()
    const title = "history"

    const [transactions, setTransactions] = useState(null)
    const [allData, dispatch] = useReducer(transactionReducer, null);
    const theme = useTheme()
    const [value, setValue] = useState(0)
    const [openDetails, setOpenDetails] = useState(false)
    const [openModalDelete, setOpenModalDelete] = useState(false)
    const [transactionDetails, setTransactionDetails] = useState(null)
    const [period, setPeriod] = useState(parseInt(dayjs(Date()).format('M')))
    const [filter, setFilter] = useState(0)
    const [categories, setCategories] = useState(categoryList.map((el) =>{
        return {name:el, checked: false}
    }))

    // console.log('transactions : ' , transactions)

    function handleFilterChange(event){
        setFilter(parseInt(event.target.value))
        sortData(allData, event.target.value, period)
    }

    function handleClickOpenDetails(transaction){
        setTransactionDetails(transaction)
        setOpenDetails(true)
    }
  
    function handleCloseDetails(){
        setOpenDetails(false)
    }

    function handleOpenModalDelete(){
        setOpenModalDelete(true)
    }

    function handleCloseModalDelete(){
        setOpenModalDelete(false)
    }
  
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
  
    function addTransaction(){
        navigate("/expenses/transaction/manage")
    }

    function modifyTransaction(id){
        navigate("/expenses/transaction/manage/" + id)
    }

    function performDeleteTransaction(id){
        console.log("Delete transaction : " , id)
        dispatch({type: 'delete', payload: id})
        let newArray = transactions.filter((el) => el.id !== id)
        setTransactions(newArray)
       
        handleCloseModalDelete()
        handleCloseDetails()
    }

    const handleChangePeriod = (event) => {
        const value = parseInt(event.target.value)
        setPeriod(value)
        sortData(allData, filter, value)
    }

    function is_included(start, end, month){
        let isCurrentYear = table().find((el)=> el.index === month).currentYear
        const year = isCurrentYear?dayjs().year():dayjs().year() -1
        month = month - 1
        const startMonth = dayjs().year(year).month(month).date(1) // C   start // A
        const endMonth = dayjs().year(year).month(month).date(31) // D    end // B
        // console.log("end : ", dayjs(end), startMonth, dayjs(end).diff(startMonth))
        // console.log("month :", month)
        // console.log("1ere condition : ", dayjs(start).diff(startMonth) < 0 , dayjs(end).diff(startMonth) > 0, dayjs(start).diff(startMonth) < 0 && dayjs(end).diff(startMonth) > 0)
        // console.log("2eme condition : ", dayjs(start).diff(startMonth) > 0 , dayjs(start).diff(endMonth) < 0, dayjs(start).diff(startMonth) > 0 && dayjs(start).diff(endMonth) < 0)
        if( (dayjs(start).diff(startMonth) < 0 && dayjs(end).diff(startMonth) > 0)
            || (dayjs(start).diff(startMonth) > 0 && dayjs(start).diff(endMonth) < 0)
        )return true
        return false
    }

    function sortData(json, filterToUse = 0, periodSelected = period){
        const today = dayjs(Date());
        const jsonFiltered = json.filter((item) => today.diff(dayjs(item.spentAt)) < 28844000000);
        const arraySorted = jsonFiltered.sort(function(a,b){
            if(b.spentAt === a.spentAt)return new Date(b.updatedAt) - new Date(a.updatedAt)            
            return new Date(b.spentAt) - new Date(a.spentAt)
        })
        // 0 -> Toutes
        // 1 -> Dépenses
        // 2 -> Revenus
        // 3 -> Transactions ponctuelles
        // 4 -> Transactions régulières
        // 5 -> Par catégories
        let filteredExpenses
        switch (parseInt(filterToUse)) {
            case 0:
                filteredExpenses = arraySorted.filter((item) => {
                    // console.log("param : ",dayjs(item.spentAt).format('M') , periodSelected)
                    return parseInt(dayjs(item.spentAt).format('M')) === periodSelected || (item.isRegular === true && is_included(item.spentAt, item.endAt, periodSelected))
                })
                break
            case 1:
                filteredExpenses = arraySorted.filter((item) => {
                    return parseInt(dayjs(item.spentAt).format('M')) === periodSelected && item.isExpense === true
                })
                break
            case 2:
                filteredExpenses = arraySorted.filter((item) => {
                    return parseInt(dayjs(item.spentAt).format('M')) === periodSelected && item.isExpense === false
                })
                break
            case 3:
                filteredExpenses = arraySorted.filter((item) => {
                    return parseInt(dayjs(item.spentAt).format('M')) === periodSelected && item.isRegular === false
                })
                break
            case 4:
                filteredExpenses = arraySorted.filter((item) => {
                    return parseInt(dayjs(item.spentAt).format('M')) === periodSelected && item.isRegular === true
                })
                break
            case 5:
                filteredExpenses = arraySorted.filter((item) => {
                    return parseInt(dayjs(item.spentAt).format('M')) === periodSelected && categories[item.category].checked === true
                })
                break
            default:
                filteredExpenses = arraySorted.filter((item) => {
                    return parseInt(dayjs(item.spentAt).format('M')) === periodSelected
                })
                break
        }
        setTransactions(filteredExpenses)
    }

    function handleFilterChangeCategory(value){
        let newArray = categories.map((el, i) => {
            if(i === value){
                el.checked = !el.checked
            }
            return el
        })
        setCategories(newArray)
        sortData(allData, 5)
    }

    useEffect(() => {
        if(allData === null){
            dispatch({type: 'get'})
        }
    }, [allData])

    useEffect(() => {
        if(transactions === null){
            if(allData !== null){
                sortData(allData, filter,period)
            }
        }
    }, [transactions, allData])

    return (
        <Layout title={title} >
            <Helmet>
                <title>Expenses - Consulter votre historique</title>
                <link rel="canonical" href={"https://expenses.johan-clement.fr/history"} /> 
                <meta name="robots" content="index,follow" />
                <meta name="description" content={`Expenses vous aide à suivre vos dépenses. Facile à utiliser et optimisé pour mobile, cette application peut vous suivre partout.`} />
            </Helmet>
            <Container>
                <main className="mx-auto md:w-1/2">
                    {transactions === null || allData === null?
                        <>
                            <p className="text-center font-bold mt-60">Chargement...</p>
                        </>
                    :
                        <>
                            <h1 className="text-center font-bold mt-5 mb-2 text-2xl">
                                Vos transactions du mois
                            </h1>
                            <div className="mx-auto text-center mb-4">
                                <FormControl>
                                    <InputLabel htmlFor="period-date">Période désirée</InputLabel>
                                    <Select
                                    native
                                    value={period}
                                    className="w-40"
                                    onChange={handleChangePeriod}
                                    >
                                        <MonthPeriods data={dayjs(Date()).format('M')} />
                                    </Select>
                                </FormControl>    
                            </div>

                            <TotalExpensesCard data={transactions} />

                            {allData.length > 0 ?
                                <div className="mb-12">
                                    <AppBar position="static" color="default">
                                        <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        variant="fullWidth"
                                        aria-label="full width tabs example"
                                        >
                                            <Tab label="Transactions" {...a11yProps(0)} />
                                            <Tab label="Filtres" {...a11yProps(1)} />
                                        </Tabs>
                                    </AppBar>
                                    <TabPanel value={value} index={0} className="mb-28" dir={theme.direction}>
                                        {transactions.map((transaction, i) => (
                                            <div key={i} >
                                                <button onClick={() => handleClickOpenDetails(transaction)} className="w-full">
                                                    <ExpenseCard data={transaction} />
                                                </button>
                                            </div>
                                        ))}
                                    </TabPanel>
                                    <TabPanel value={value} index={1} dir={theme.direction}>
                                        <div className="mt-4 px-5">
                                            <FormControl component="fieldset" >
                                                <FormLabel component="legend">Filtrer selon vos critères</FormLabel>
                                                <RadioGroup aria-label="filter" name="filter" value={value} onChange={handleFilterChange}>
                                                    <FormControlLabel value="0" checked={filter===0?true:false} control={<Radio />} label="Toutes" />
                                                    <FormControlLabel value="1" checked={filter===1?true:false} control={<Radio />} label="Dépenses" />
                                                    <FormControlLabel value="2" checked={filter===2?true:false} control={<Radio />} label="Revenus" />
                                                    <FormControlLabel value="3" checked={filter===3?true:false} control={<Radio />} label="Transactions ponctuelles" />
                                                    <FormControlLabel value="4" checked={filter===4?true:false} control={<Radio />} label="Transactions régulières" />
                                                    <FormControlLabel value="5" checked={filter===5?true:false} control={<Radio />} label="Par catégorie" />
                                                </RadioGroup>
                                            </FormControl>  
                                            {filter === 5?(
                                                <div className="ml-10 mb-10">
                                                    {categoryList.map((element, i) => (
                                                        <div key={i}>
                                                        <FormControlLabel 
                                                            control={<Checkbox checked={categories[i].checked} onChange={() => handleFilterChangeCategory(i)} name={"category" + i} />}
                                                            label={element}
                                                        />
                                                        </div>    
                                                    ))}
                                                    
                                                </div>     
                                            ):null} 
                                        </div>
                                    </TabPanel>
                                </div>
                            :
                                <>
                                    <p className="text-center">Aucune transaction enregistrée sur ce compte</p>
                                    <p className="text-center">Cliquez sur le bouton + pour ajouter vos transactions</p>
                                </>
                            }
                        </>
                    }
                </main>
                <Dialog fullScreen open={openDetails} onClose={handleCloseDetails} TransitionComponent={Transition}>
                    <AppBar>
                        <Toolbar className="flex justify-between">
                            <IconButton edge="start" color="inherit" onClick={handleCloseDetails} aria-label="close">
                                <CloseIcon /><span className="text-base ml-1">Fermer</span>
                            </IconButton>
                            {transactionDetails?(
                                <button onClick={()=> modifyTransaction(transactionDetails.id)}>
                                    <span className="text-base ml-1">Modifier</span>
                                </button>    
                            ):null}
                        </Toolbar>
                    </AppBar>
                    <div className="h-full">
                        <div className="mt-20 text-center">
                            <h1 className="font-bold uppercase text-xl">Détails</h1>
                        </div>
                        <div className="px-4 mt-4 mx-auto md:w-1/2">
                            <ExpenseCardDetails data={transactionDetails} />
                        </div>
                        <div className="absolute bottom-4 w-full text-center">
                            <Button onClick={handleOpenModalDelete}>
                                <span className="text-red-600">Supprimer cette transation</span>
                            </Button>    
                        </div>
                    </div>
                    <Dialog
                        open={openModalDelete}
                        onClose={handleCloseModalDelete}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle>Confirmer la suppression</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Cette action est définitive. Veuillez confirmer la suppression de cette transaction.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleCloseModalDelete} color="primary" autoFocus>
                            Annuler
                        </Button>
                        <Button onClick={() => performDeleteTransaction(transactionDetails.id)} color="secondary">
                            Confirmer
                        </Button>
                        </DialogActions>
                    </Dialog>
                </Dialog>
            </Container>
            <div className="fixed bottom-16 right-5">
                <Fab color="primary" aria-label="add" onClick={addTransaction}>
                    <AddIcon />
                </Fab>    
            </div>
        </Layout>
    )
}